import {NotificationList} from 'src/components/pages/sales/notification/NotificationList'

export {NotificationList}